import {format, isDate} from 'date-fns'
import i18next from 'i18next'
import {id as localeID, enUS as localeUS} from 'date-fns/locale'

type TDateFormatOption = {
  showtime: boolean,
  format?: string
}

/**
 * Mengubah format tanggal dari `07-11-2023 16:09:04`
 * - ID (Indonesia) `11 Juli 2023`
 * - EN (Inggris) `11 July 2023`
 */
export default function dateformat(date: string, options?: TDateFormatOption) {
  try {
    if (!date) return ''

    const code = i18next.language
    const locale = code === 'id' ? localeID : localeUS
    const newDate = new Date(date)

    if (!isDate(newDate)) return 'INVALID_DATE'

    const formater: string = options?.showtime ? 'dd MMMM yyy - HH:mm:ss' : (options?.format ? options?.format : 'dd MMMM yyy')

    return format(newDate, formater, {locale})
  } catch (error) {
    return 'INVALID_DATE'
  }
}
